/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type DeleteRunModal_run$ref: FragmentReference;
declare export opaque type DeleteRunModal_run$fragmentType: DeleteRunModal_run$ref;
export type DeleteRunModal_run = {|
  +id: string,
  +machine: {|
    +id: string,
    +name: string,
    +type: {|
      +id: string,
      +name: string,
    |},
  |},
  +$refType: DeleteRunModal_run$ref,
|};
export type DeleteRunModal_run$data = DeleteRunModal_run;
export type DeleteRunModal_run$key = {
  +$data?: DeleteRunModal_run$data,
  +$fragmentRefs: DeleteRunModal_run$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "DeleteRunModal_run",
  "type": "Run",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "machine",
      "storageKey": null,
      "args": null,
      "concreteType": "Machine",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "type",
          "storageKey": null,
          "args": null,
          "concreteType": "MachineType",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/)
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a8670d61107555e9b5d129b5c0b2a809';
module.exports = node;
